import styled from 'styled-components/macro';
import { TYPOGRAPHY } from 'styleguide';

const FormLabel = styled.label`
  display: block;
  width: 100%;
  ${TYPOGRAPHY.button}
  cursor: pointer;

  svg {
    opacity: 0.6;
    transition: opacity 0.25s;
  }

  input[type='file'] {
    display: none;
  }

  &:hover {
    svg {
      opacity: 1;
    }
  }
`;

export default FormLabel;
